import React from 'react';
import { CommentStart, CommentEnd } from '../comments';
import { useConfig } from '../config-context';
export function SectionConditionalTableItems(props) {
    var children = props.children;
    var config = useConfig();
    if (!config.renderComments) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CommentStart, null),
        React.createElement("table", { role: "presentation", border: "0", cellPadding: "0", cellSpacing: "0" },
            React.createElement("tr", null,
                React.createElement(CommentEnd, null),
                children,
                React.createElement(CommentStart, null))),
        React.createElement(CommentEnd, null)));
}
//# sourceMappingURL=section-conditional-table-items.js.map